import { Component, OnInit } from '@angular/core';
import {MatDialog, MatDialogRef} from "@angular/material/dialog";
import {FadeService} from "../../../services/fade.service";
import {fade} from "../../../models/fade";
import {ProyectoService} from "../../../services/proyecto.service";
import {InfoFadesComponent} from "./info-fades/info-fades.component";
import {Localiser} from "../../../services/localiser";
import { FadeTimesService } from 'src/app/services/fade-times.service';
import { fadeTime } from "../../../models/fadeTime";

@Component({
  selector: 'app-lista-fades',
  templateUrl: './lista-fades.component.html',
  styleUrls: ['./lista-fades.component.css']
})
export class ListaFadesComponent implements OnInit {

  page: string = "lista";

  // Lista Fade
  fades: fade[];

  // New Fade or Edit fade
  id: string;
  fade_in: number;
  max_t: number;
  fade_out: number;
  min_t: number;
  work_max: number;
  work_min: number;
  nombre: string;
  descripcion: string;

  fadeTimes: fadeTime[];
  errorsArray: string[] = [];

  selectedFadeInTimeKey: number = 0;
  selectedFadeOutTimeKey: number = 0;
  optionsFadeTime: { key: number, value: string }[] = [
    { key: 0, value: '0' },
    { key: 1, value: '0,7' },
    { key: 2, value: '1,0' },
    { key: 3, value: '1,4' },
    { key: 4, value: '2,0' },
    { key: 5, value: '2,8' },
    { key: 6, value: '4,0' },
    { key: 7, value: '5,7' },
    { key: 8, value: '8,0' },
    { key: 9, value: '11,3' },
    { key: 10, value: '16,0' },
    { key: 11, value: '22,6' },
    { key: 12, value: '32,0' },
    { key: 13, value: '45,3' },
    { key: 14, value: '64,0' },
    { key: 15, value: '90,5' }
  ];
  constructor(public dialogRef: MatDialogRef<ListaFadesComponent>, private fadeService: FadeService,
              private proyectoService: ProyectoService, public matDialog: MatDialog, private fadeTimesService: FadeTimesService,
              public localiser: Localiser) { }

  ngOnInit(): void {
    this.page = "lista";
    this.getFades();

    console.log('ON INIT LISTA FADES');
    this.getFadeTimes();
  }

  changePageToNew() {
    this.page = "new";
    this.fade_in = 0;
    this.max_t = 0;
    this.fade_out = 0;
    this.min_t = 0;
    this.work_max = 0;
    this.work_min = 0;
    this.nombre = "";
    this.descripcion = "";
  }

  changePageToLista() {
    this.page = "lista";
  }

  getFades() {
    this.fadeService.getByIdProyecto(this.proyectoService.getProyectoActual().idProyecto).subscribe(result => {
      this.fades = <Array<fade>> result;
      console.log(result);
    });
  }

  checkCreateProfile() {
    return this.max_t >= 0 && this.min_t >= 0 && this.work_min >= 0 && this.work_max >= 0 && this.fade_in >= 0 && this.fade_out >= 0 && this.nombre.length > 0;
  }

  getErrorsCreatingProfile() {
    this.errorsArray = [];
    
    if (this.max_t < 0) {
      this.errorsArray.push("Waiting time must be a non-negative number");
    }
    if (this.max_t == undefined) {
      this.errorsArray.push("Waiting time field cannot be empty");
    }

    if (this.min_t < 0) {
      this.errorsArray.push("Low waiting time must be a non-negative number");
    }
    if (this.min_t == undefined) {
      this.errorsArray.push("Low waiting time field cannot be empty");
    }

    if (this.fade_in < 0) {
      this.errorsArray.push("Fade In time must be a non-negative number");
    }
    if (this.fade_in == undefined) {
      this.errorsArray.push("Fade In time field cannot be empty");
    }

    if (this.fade_out < 0) {
      this.errorsArray.push("Fade Out time must be a non-negative number");
    }
    if (this.fade_out == undefined) {
      this.errorsArray.push("Fade Out time field cannot be empty");
    }

    if (this.work_max < 0) {
      this.errorsArray.push("Maximum % must be a non-negative number");
    }
    if (this.work_max == undefined) {
      this.errorsArray.push("Maximum % field cannot be empty");
    }

    if (this.work_min < 0) {
      this.errorsArray.push("Minimum % must be a non-negative number");
    }
    if (this.work_min == undefined) {
      this.errorsArray.push("Minimum % field cannot be empty");
    }

    if (this.nombre.length == 0) {
      this.errorsArray.push("Fade profile name field cannot be empty");
    }
  }

  newFade() {
    let fade: fade = {
      id: '0',
      fade_in: this.fade_in + '',
      max_t: (this.max_t * 60) + '',
      fade_out: this.fade_out + '',
      min_t: (this.min_t * 60) + '',
      work_max: this.work_max + '',
      work_min: this.work_min + '',
      nombre: this.nombre,
      descripcion: this.descripcion,
      idProyecto: this.proyectoService.getProyectoActual().idProyecto
    }
    
    // cambiamos el tiempo nominal por el indice fadeTime
    fade.fade_in = this.selectedFadeInTimeKey.toString();
    fade.fade_out = this.selectedFadeOutTimeKey.toString();
    
    if (this.checkCreateProfile()) {
      this.errorsArray = [];

      this.fadeService.new(fade).subscribe(result => {
        this.dialogRef.close();
        
      })
    } else {
      this.getErrorsCreatingProfile();
    }
  }

  editFadePage(fade: fade) {
    console.log('entre en edit fade page');
    console.log('fade: ' + fade);
    console.log('fade.fade_in: ' + fade.fade_in);
    console.log('fade.fade_out: ' + fade.fade_out);

    this.page = "edit";
    this.id = fade.id;
    this.fade_in = +fade.fade_in;
    this.max_t = (+fade.max_t / 60);
    this.fade_out = +fade.fade_out;
    this.min_t = (+fade.min_t / 60);
    this.work_max = +fade.work_max;
    this.work_min = +fade.work_min;
    this.nombre = fade.nombre;
    this.descripcion = fade.descripcion;

    this.selectedFadeInTimeKey = +fade.fade_in;
    this.selectedFadeOutTimeKey = +fade.fade_out;

    console.log('fade.fade_in: ' + fade.fade_in);
    console.log('fade.fade_in: ' + fade.fade_in);
    console.log('selectedFadeInTimeKey: ' + this.selectedFadeInTimeKey);
    console.log('selectedFadeOutTimeKey: ' + this.selectedFadeOutTimeKey);

  }

  updateFade() {
    let fade: fade = {
      id: this.id,
      fade_in: this.fade_in + '',
      max_t: (this.max_t * 60) + '',
      fade_out: this.fade_out + '',
      min_t: (this.min_t * 60) + '',
      work_max: this.work_max + '',
      work_min: this.work_min + '',
      nombre: this.nombre,
      descripcion: this.descripcion,
      idProyecto: this.proyectoService.getProyectoActual().idProyecto
    }

    // cambiamos el tiempo nominal por el indice fadeTime
    fade.fade_in = this.selectedFadeInTimeKey.toString();
    fade.fade_out = this.selectedFadeOutTimeKey.toString();

    console.log(fade);

    if (this.checkCreateProfile()) { 
      this.errorsArray = [];

      this.fadeService.update(fade).subscribe(result => {
        this.dialogRef.close();
      }, error => {
        this.dialogRef.close();
      });
    } else {
      this.getErrorsCreatingProfile();
    }
  }

  deleteFadePage(fade: fade) {
    this.page = "delete";
    this.id = fade.id;
    this.fade_in = +fade.fade_in;
    this.max_t = +fade.max_t;
    this.fade_out = +fade.fade_out;
    this.min_t = +fade.min_t;
    this.work_max = +fade.work_max;
    this.work_min = +fade.work_min;
    this.nombre = fade.nombre;
    this.descripcion = fade.descripcion;

    // convertimos el fadeTime en su valor nominal asociado
    // cruzar las dos tablas para obtener el fade time nominal
    const fadeInTimeAux = this.fadeTimes.find(fadeTime => fadeTime.fadeTime === parseInt(fade.fade_in));
    if (fadeInTimeAux) {
      this.fade_in = fadeInTimeAux.nominalValue;
    } else {
      console.error('No se encontró ninguna coincidencia con fadeTime = ' + fade.fade_in);
    }
    const fadeOutTimeAux = this.fadeTimes.find(fadeTime => fadeTime.fadeTime === parseInt(fade.fade_out));
    if (fadeOutTimeAux) {
      this.fade_out = fadeOutTimeAux.nominalValue;
    } else {
      console.error('No se encontró ninguna coincidencia con fadeTime = ' + fade.fade_out);
    }
  }

  deleteFade() {
    this.fadeService.delete(this.id).subscribe(result => {
      this.dialogRef.close();
    }, error => {
      this.dialogRef.close();
    });
  }

  maxLengthCheckMaxWork(event) {
    if (event.target.value.length >= event.target.max.length) {
      let number = 100;
      event.target.value = +number;
      this.work_max = +number;
    }
  }

  maxLengthCheckMinWork(event) {
    if (event.target.value.length >= event.target.max.length) {
      let number = 100;
      event.target.value = +number;
      this.work_min = +number;
    }
  }

  maxLengthCheckFadeIn(event) {
    if (event.target.value.length >= event.target.max.length) {
      let number = event.target.value.slice(0, event.target.max.length);;
      event.target.value = +number;
      this.fade_in = +number;
    }
  }

  maxLengthCheckFadeOut(event) {
    if (event.target.value.length >= event.target.max.length) {
      let number = event.target.value.slice(0, event.target.max.length);;
      event.target.value = +number;
      this.fade_out = +number;
    }
  }

  maxLengthCheckMaxT(event) {
    console.log("event value is -> " + event.target.value);

    if (event.target.value.length >= event.target.max.length) {
      let number = event.target.value.slice(0, event.target.max.length);;
      event.target.value = +number;
      this.max_t = +number;
    }
  }

  maxLengthCheckMinT(event) {
    if (event.target.value.length >= event.target.max.length) {
      let number = event.target.value.slice(0, event.target.max.length);;
      event.target.value = +number;
      this.min_t = +number;
    }
  }

  openInfo() {
    this.matDialog.open(InfoFadesComponent, {
      width: '50%',
      height: '40%'
    });
  }

  onCancelClick(): void {
    this.dialogRef.close();
  }
  
  getFadeTimes() {
    this.fadeTimesService.getFadeTimes().subscribe(result => {
      this.fadeTimes = <Array<fadeTime>> result;
    });
  }
}
